import { simpleSet } from '@r/reducers/utils';

const setRightSideCabinetMenuMode = simpleSet as
  redux.reducers.flags.rightSideCabinetMenuOpen;
export const rightSideCabinetMenuOpen = setRightSideCabinetMenuMode(
  'SET_RIGHT_SIDE_CABINET_MENU_OPEN',
  true
);
